<template>
    <div>
      <v-row>
        <v-col>
          <upload-excel
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          />
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" v-if="isCliente == 0">
            <v-combobox
                v-model="clienteG"
                :items="clientes"
                item-text="name"
                item-value="id"
                label="Cliente"
                append-icon="mdi-handshake"
                return-object
            ></v-combobox>
          </v-col>
          <v-col>
              <v-btn color="primary" small @click="crearGuias()">Crear Guias</v-btn> -
              <v-btn color="info" small @click="limpiar()">Limpiar</v-btn>
          </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
          :items="tableData"
          :headers="headers"
          class="elevation-1"
          >
          </v-data-table>
        </v-col>
      </v-row>
      <v-row v-if="procesado">
        <v-col>
           <v-alert dense type="info">
            Se han creado satisfactoriamente las siguientes Guías!!!
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="procesado">
        <v-col>
          <v-simple-table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tipo</th>
                  <th>Guía Creada</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(guia, index) in guiasCreadas" :key="index">
                  <td>{{guia.No}}</td>
                  <td>{{guia.tipo}}</td>
                  <td>{{guia.guia_interna}}</td>
                </tr>
              </tbody>
            </v-simple-table>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <waiting :totalGuias="tableData.length" :currentGuia="currentGuia" :guiaCreada="guiaCreada" />
      </v-overlay>
      <v-dialog v-model="erroresDlg" width="800px" transition="dialog-bottom-transition" persistent>
        <v-card elevation="24" outlined>
          <v-toolbar dark color="#96298A" dense>
            <v-toolbar-title>
              Errores : <strong> {{errores.length}} </strong>
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn icon dark @click="erroresDlg = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-divider vertical />
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Guia No</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(err, index) in errores" :key="index">
                  <td><strong>{{err.guia}}</strong></td>
                  <td>{{err.error}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </template>

  <script>
  import UploadExcel from "../components/UploadExcel.vue";
  import Waiting from "../components/WaitingCreandoGuias.vue";
  import apicon from '../plugins/apicon';
  const Ajv = require('ajv');
  const ajv = new Ajv({allErrors:true});
  export default {
    name:"CargarManifiestoCL",
    created: function () {},
    components: {
      UploadExcel,
      Waiting,
    },
    data() {
      return {
        overlay: false,
        tableData: [],
        tableHeader: [],
        currentGuia: 1,
        guiaCreada: null,
        erroresDlg : false,
        errores:[],
        clientes: [],
        clienteG: null,
        headers: [
          { text: "Guia Master", value: "guia_master" },
          { text: "Guia Hija", value: "guia_hija" },
          { text: "Shipper", value: "shipper" },
          { text: "Destinatario", value: "destinatario" },
          { text: "Direccion", value: "direccion" },
          { text: "Valor", value: "valor" },
          { text: "No Articulos", value: "no_articulos" },
          { text: "Descripcion", value: "descripcion" },
          { text: "Provincia", value: "provincia" },
          { text: "Ciudad", value: "ciudad" },
          { text: "Telefono", value: "telefono" },
          { text: "Bultos", value: "bultos" },
          { text: "Peso KG", value: "peso_kg" },
          { text: "Remitente", value: "remitente" },
          { text: "Direccion", value: "direccion_remitente" },
          { text: "Ciudad", value: "ciudad_origen" },
          { text: "Pais", value: "pais_origen" },
          { text: "ETD", value: "etd" },
          { text: "ETA", value: "eta" },
          { text: "No Vuelo", value: "no_vuelo" },
          { text: "Client Id", value: "client_id" },
          { text: "Usuario Id", value: "id_usuario" },
          { text: "Referencia 1", value: "referencia1" },
          { text: "Referencia 2", value: "referencia2" },
          { text: "Referencia 3", value: "referencia3" },
        ],
        schema : {
          type: 'object',
          properties: {
            cliente :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            guia_master :{
              type: "string",
              minimun: 2,
              maxLength : 30,
            },
            guia_hija :{
              type: "string",
              minimun: 2,
              maxLength : 30,
            },
            shipper :{
              type: "string",
              minimun: 2,
              maxLength : 80,
            },
            destinatario :{
              type: "string",
              minimun: 2,
              maxLength : 80,
            },
            cedula :{
              type: "string",
              minimun: 2,
              maxLength : 30,
            },
            direccion :{
              type: "string",
              minimun: 2,
              maxLength : 250,
            },
            descripcion :{
              type: "string",
              minimun: 2,
              maxLength : 350,
            },
            provincia :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            ciudad :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            cod_postal :{
              type: "string",
              minimun: 2,
              maxLength : 30,
            },
            telefono :{
              type: "string",
              minimun: 2,
              maxLength : 30,
            },
            bultos :{
              type: "string",
            },
            peso_kg :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            remitente :{
              type: "string",
              minimun: 2,
              maxLength : 80,
            },
            direccion_remitente :{
              type: "string",
              minimun: 2,
              maxLength : 250,
            },
            ciudad_origen :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            pais_origen :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            etd :{
              type: "string",
            },
            eta :{
              type: "string",
            },
            no_vuelo :{
              type: "string",
              minimun: 2,
              maxLength : 30,
            },
            referencia1 :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            referencia2 :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
            referencia3 :{
              type: "string",
              minimun: 2,
              maxLength : 50,
            },
          },
          required: [
            "cliente",
            "guia_master",
            "guia_hija",
            "shipper",
            "destinatario",
            "direccion",
            "valor",
            "no_articulos",
            "descripcion",
            "provincia",
            "ciudad",
            "telefono",
            "bultos",
            "peso_kg",
            "remitente",
            "direccion_remitente",
            "ciudad_origen",
            "pais_origen",
            "no_vuelo",
            ]
        },
        /*replaceable: {
            contacto_c : "Contacto",
            empresa_c : "Empresa",
            telefono_c : "Telefono",
            direccion1_c : "Dirección 1",
            direccion2_c : "Dirección 2",
            ciudad_c : "Ciudad",
            descripcion : "Descripción",
            tipo : "Tipo",
            servicio : "Servicio",
        },*/
        guiasCreadas : [],
        procesado: false,
        cliente: null,
        sheetName: null,
        isCliente: 1
      };
    },
    methods: {
      beforeUpload(file) {
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (isLt1M) {
          return true;
        }
        this.$swal("No se pueden subir archivos mayortes a 1MB");
        return false;
      },
      handleSuccess({ results, header, sheetName }) {
        this.tableData = results;
        this.tableHeader = header;
        this.sheetName = sheetName;
        this.procesado = false;
        this.guiasCreadas = [];
        this.currentGuia = 1;
      },
      limpiar: function(){
        this.tableData = [];
        this.tableHeader = [];
        this.guiasCreadas = [];
        this.procesado = false;
        this.currentGuia = 1;
        this.clienteG = null;
      },
      crearGuias:async  function () {
        if(this.clienteG == null){
          this.$swal('Por favor seleccione el cliente al que le asignara las guias creadas');
          return;
        }
        //Verificar si hay guias
        if(this.tableData.length == 0){
          this.$swal("No ha importado datos");
          return;
        }
        //verificar que se haya importado un archivo valido
        if(this.sheetName != 'manifiesto'){
          this.$swal("El tipo de archivo importado parece no ser valido 'manifiesto' - SheetName: " + this.sheetName);
          return;
        }
        //Validar los datos de la guia
        let datosValidos = await this.validarDatosGuias();
            if(!datosValidos){
              this.$swal("Se encontraron errores de validacion, por favor corrija y vuelva a importar el archivo");
              this.erroresDlg = true;
              return;
            }
        this.overlay = true;
        for (var i = 0; i <= this.tableData.length - 1; i++) {
          //crear las piezas (solo una pieza)
            if(this.clienteG != null){
              this.tableData[i]['id_usuario'] = this.clienteG.id;
            }
            console.log(this.tableData[i]['id_usuario']);
            await apicon.saveDataApi(apicon.getApiBaseUrl() + 'compraslinea',this.tableData[i]).then((result) =>{
                if(result.status){
                  this.guiaCreada = result.data.guia_hija;
                  this.guiasCreadas.push({
                    tipo: 'CL',
                    guia_interna: result.data.guia_hija
                  });
                  this.currentGuia ++;
                }else{
                  console.log(result.data);
                }
            });
        }
        this.overlay = false
        this.tableData = [];
        this.procesado = true;
        this.currentGuia = 1;
      },
      validarDatosGuias:async function(){
        let flag = true;
        this.errores = [];
        for (var i = 0; i <= this.tableData.length - 1; i++) {
          //Verificar campos obligatorios
          let flgValidacion = await this.validarCamposObligatorios(this.tableData[i]);
          if(!flgValidacion){
            flag = false;
          }
          //Reemplazar las variable para mejor presentacion al usuario.
          //this.replaceVar();
        }
        return flag;
      },
      validarCamposObligatorios:async function(guia){
        let flag = true;
        var valid = await ajv.validate(this.schema,guia);
        if(!valid){
          flag = false;
          //For recorriendo los errores
          console.log(ajv.errors);
          for(let i = 0; i< ajv.errors.length; i++){
            this.errores.push({guia: guia.guia_hija, error: ajv.errors[i].dataPath + ' ' + ajv.errors[i].message})
          }
        }
        return flag;
      },
      fillClientes:async function () {
        await apicon.getDataApi(apicon.getApiBaseUrl() + "usuario").then((result) => {
          this.clientes = result;
        });
      },
      /*replaceVar: function(){
        let lookup = this.replaceable || {};
        Object.keys(lookup).forEach((key) => {
          for(var i=0; i < this.errores.length; i++){
           this.errores[i].error = this.errores[i].error.replace(new RegExp("\\b" + key + "\\b", "g"),lookup[key]);
          }
        });
      },*/
      /*getDatosCliente:async function(){
        await apicon.getDataApi(apicon.getApiBaseUrl() + 'usuario/' + localStorage.getItem("userid"))
              .then(async (result) => {
                this.cliente = result;
              });
      },*/
    },
    mounted:async function () {
        await apicon.setAuthHeaders();
        await this.fillClientes();
        this.isCliente = localStorage.getItem('cliente')
    },
  };
  </script>

  <style>
  </style>
